import styled from '@emotion/styled';
import { DateTime } from 'infras/datetime';
import { gray04 } from 'presentations/views/styles/color';
import { memo, useContext, useMemo } from 'react';
import { CalendarContext } from 'presentations/views/components/atoms/Calendar/reducer/CalendarContext';
import WeekHeaderCell from './WeekdayHeaderCell';
import { CalendarWeekDay } from './reducer';

interface Props {
  startedAt: DateTime;
}

const Component = memo((props: Props) => {
  const { state } = useContext(CalendarContext);

  const isLoading = !state.isReady || state.currentPage === 0;
  const dates = useMemo(() => {
    const items: DateTime[] = [];
    if (state.showRange.day) {
      for (let i = 0; i < state.showRange.day; i++) {
        const date = props.startedAt.plus({ day: i });
        const weekday = (date.weekday % 7) as CalendarWeekDay;
        if (state.hiddenWeekdays.includes(weekday)) continue;
        items.push(date);
      }
    }
    return items;
  }, [props.startedAt, state.showRange]);

  return (
    <Header maxCols={dates.length}>
      {dates.map((date: DateTime, i: number) => (
        <WeekHeaderCell
          key={date.toMillis()}
          date={date}
          isLoading={isLoading}
          isHoliday={[0, 6].includes(date.weekday % 7)}
        />
      ))}
    </Header>
  );
});

const Header = styled.div<{ maxCols: number }>`
  width: inherit;
  flex: 1 1 0%;
  display: grid;
  grid-template-columns: ${(props) =>
    `repeat(${props.maxCols}, minmax(1px, 1fr))`};
  grid-template-rows: repeat(1, minmax(18px, 1fr));
  border-bottom: 1px solid ${gray04};
`;

export default Component;
